import { render, staticRenderFns } from "./createOverTimeLeave.vue?vue&type=template&id=870ca674&scoped=true&"
import script from "./createOverTimeLeave.vue?vue&type=script&lang=js&"
export * from "./createOverTimeLeave.vue?vue&type=script&lang=js&"
import style0 from "./createOverTimeLeave.vue?vue&type=style&index=0&id=870ca674&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870ca674",
  null
  
)

export default component.exports